import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { IsUserLoggedIn } from "../../utils/login";

const RequireAuth = ({ allowedRoles, children }) => {
  const { auth } = useAuth();
  const location = useLocation();

  const isLoggedIn = IsUserLoggedIn();

  if (isLoggedIn && auth.isAuthenticated) {
    if (allowedRoles.includes(auth?.roles)){
      return <Outlet>{children}</Outlet>;
    } else {
      return <Navigate to="/unauthorized" state={{ from: location }} />;
    }
  } else {
    return <Navigate to="/login" state={{ from: location }} />;
  }
};

export default RequireAuth;
